// extracted by mini-css-extract-plugin
export default {"end":"styles_end__tCqg1"};